/**
 * Money — renders a monetary value with JetBrains Mono, tabular numerals,
 * and semantic colour (positive = ink, negative = neg token).
 */

export function Money({
  amount,
  currency,
  decimals = 3,
  className,
}: {
  /** Numeric value or a string representation (will be parsed). */
  amount: number | string;
  currency?: string;
  decimals?: number;
  className?: string;
}) {
  const num = typeof amount === 'number' ? amount : parseFloat(amount);
  const isNeg = Number.isFinite(num) && num < 0;
  const isZero = Number.isFinite(num) && num === 0;
  const display = Number.isFinite(num)
    ? Math.abs(num).toFixed(decimals)
    : String(amount);

  return (
    <span
      className={[
        'font-mono tabular-nums',
        isNeg ? 'text-neg' : isZero ? 'text-ink-muted' : 'text-ink',
        className,
      ]
        .filter(Boolean)
        .join(' ')}
    >
      {isNeg && '−'}
      {currency && <span className="mr-0.5 text-ink-muted">{currency} </span>}
      {display}
    </span>
  );
}

/** Compact version for tight table cells — no currency prefix. */
export function MoneyCell({
  amount,
  decimals = 3,
}: {
  amount: number | string;
  decimals?: number;
}) {
  return <Money amount={amount} decimals={decimals} />;
}
